var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCopy2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 11.6667H14.1554C15.151 11.6667 15.6487 11.6666 16.029 11.4729C16.3635 11.3024 16.6358 11.0305 16.8062 10.696C17 10.3157 17 9.81792 17 8.82227V3.84446C17 2.84882 17 2.35099 16.8062 1.9707C16.6358 1.63619 16.3635 1.36421 16.029 1.19377C15.6487 1 15.1512 1 14.1556 1H9.17785C8.18222 1 7.68403 1 7.30374 1.19377C6.96924 1.36421 6.69747 1.63619 6.52703 1.9707C6.33327 2.35099 6.33327 2.84886 6.33327 3.84451V6.3334M1 14.1556V9.17784C1 8.18219 1 7.68432 1.19376 7.30404C1.3642 6.96953 1.63597 6.69754 1.97047 6.5271C2.35076 6.33333 2.84895 6.33333 3.84458 6.33333H8.8223C9.81794 6.33333 10.3154 6.33333 10.6957 6.5271C11.0302 6.69754 11.3025 6.96953 11.473 7.30404C11.6667 7.68432 11.6667 8.18215 11.6667 9.1778V14.1556C11.6667 15.1512 11.6667 15.6491 11.473 16.0294C11.3025 16.3639 11.0302 16.6358 10.6957 16.8062C10.3154 17 9.81794 17 8.8223 17H3.84458C2.84895 17 2.35076 17 1.97047 16.8062C1.63597 16.6358 1.3642 16.3639 1.19376 16.0294C1 15.6491 1 15.1513 1 14.1556Z",
    stroke: "url(#paint0_linear_9233_22754)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9233_22754",
    x1: -8,
    y1: -7,
    x2: 26,
    y2: 25.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#678AF5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy2);
export default __webpack_public_path__ + "static/media/Copy2.f41556c656f9dd3bcd9c376f4378cf72.svg";
export { ForwardRef as ReactComponent };